import { styled } from '@mui/material/styles';
import { StylesConfig } from 'react-select';
import { Box, Stack } from '@mui/material';
import { AlumniSansFont } from '../../styles/fonts';
import LocalizedLink from '../Link/localized-link';

export const LinkStyled = styled(LocalizedLink)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '24px',
  marginBottom: '10px',
}));

export const TitleWrapperStyled = styled(Box)(({ theme }) => ({
  flex: 1,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '29px',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const BurgerMenuStyled = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto',
  },
}));

export const dropDownStyles: StylesConfig<any, false, any> = {
  option: (provided: any, state: any) => {
    return {
      ...provided,
      background: '#fff',
      color: '#000',
      ':active': {
        background: '#000',
        color: '#fff',
      },
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '19px',
      fontStule: 'normal',
      fontWeight: 360,
    };
  },
  input: (provided: any) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  placeholder: (provided: any) => ({
    ...provided,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '19px',
    fontStule: 'normal',
    fontWeight: 360,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    boxShadow: 'none',
    padding: 0,
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 5,
    padding: 0,
    margin: 0,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: 0,
    background: '#fff',
    color: '#000',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    transition: 'all .2s ease',
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
};

export const StyledDropDownMenu = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: '0%',
  width: '100%',

  alignItems: 'center',
  background: 'white',
  padding: '13px',
  zIndex: 10000,
  boxShadow: `0px 2px 2px ${theme.palette.grey[100]}`,
}));

export const StyledDropDownMenuItem = styled(Box)(({ theme }) => ({
  color: '#171717',
  padding: '3px 4px',
  cursor: 'pointer',
}));

export const Item = styled(Box)(({ theme }) => ({
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 300,
  color: '#191A1B',
  letterSpacing: '0px',
  cursor: 'pointer',
}));

export const PriceItem = styled(Box)(({ theme }) => ({
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 300,
  color: '#191A1B',
  letterSpacing: '0px',
  cursor: 'pointer',
}));

// export const HeaderItemStyled = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   justifyContent: 'space-between',
//   [theme.breakpoints.down('md')]: {
//     padding: '0 20px',
//   },
// }));

// export const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   top: '0',
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));

// export const SearchStyled = styled('div')(({ theme }) => ({
//   position: 'relative',
//   minWidth: '370px',
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.white, 0.15),
//   '&:hover': {
//     backgroundColor: alpha(theme.palette.common.white, 0.25),
//   },
//   fontFamily: 'Verdana',
//   marginRight: theme.spacing(2),
//   marginLeft: 0,
//   width: '100%',

//   [theme.breakpoints.down('md')]: {
//     minWidth: '270px',
//     display: 'none',
//   },
// }));

// export const SearchMobileStyled = styled('div')(({ theme }) => ({
//   display: 'none',
//   [theme.breakpoints.down('md')]: {
//     borderTop: 'solid 1px black',
//     display: 'block',
//     position: 'relative',
//     backgroundColor: alpha(theme.palette.common.white, 0.15),
//     '&:hover': {
//       backgroundColor: alpha(theme.palette.common.white, 0.25),
//     },
//     padding: '8px',
//     marginRight: theme.spacing(2),
//     marginLeft: 0,
//     width: '100%',
//   },
// }));

// export const StyledInputBase = styled(InputBase)(({ theme, className }) => ({
//   color: 'success',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     width: '100%',
//     className: className,
//     fontFamily: 'Roboto',
//     [theme.breakpoints.up('md')]: {
//       width: '20ch',
//     },
//   },
// }));

// export const HeaderToolbar = styled('div')(() => ({
//   display: 'flex',
//   flexGrow: 0,
//   alignItems: 'center',
//   '& .wishlist-container': {
//     position: 'absolute',
//     top: '29.2px',
//     right: 'calc(11.4% - 14px)',
//     marginRight: '2px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: 4,
//   },
//   '.currency': {
//     marginLeft: '5.93px',
//     marginTop: '12px',
//     div: {
//       // zIndex: "1",
//     },
//   },
//   '.currencyIcon': {
//     position: 'relative',
//     top: '-20px',
//     //zIndex: "0",
//   },
//   '& .wishlist-count': {
//     fontFamily: 'Verdana',
//     color: '#0d0d0e',
//     fontSize: '16px',
//     fontWeight: '400',
//     marginBottom: '3px',
//     '@media only screen and (max-width: 768px)': {
//       marginBottom: '0',
//     },
//   },
// }));

// export const SearchIconContainer = () => (
//   <SearchIconWrapper>
//     <SearchIcon
//       style={{
//         color: HEADER_TEXT_COLOR,
//       }}
//     />
//   </SearchIconWrapper>
// );

// export const SearchDropdownContainer = styledComponent.div<any>`
//   position: absolute;
//   font-size: 14px;
//   font-weight: 400;
//   font-family:Verdana;
//   right: calc(11.4% + 23.3px);
//   top: 20px;

//   .dropdown-menu {
//     position:absolute;
//     left: 0;
//     top: calc(100% + 0.25rem);
//     width:100%;
//     background-color: #ffffff;
//     padding: .75rem;
//     box-shadow:0 2px 5px 0 rgba(0,0,0,0.1);
//     border-radius: 4px;
//     z-index:9;
//     max-height:250px;
//     overflow:auto;
//     overflow-x:hidden;

//     ::-webkit-scrollbar {
//       width:0;
//     }
//   }

//   .desktop {
//     display:flex;
//     left: 32px;
//   }

//   .mobile {
//     display: none;
//     top: 100%;
//   }

//   .desktop,
//   .mobile {
//     flex-direction: column;
//   }

//   .dropdown-item {
//     color:#171717;
//     font-family: 'Verdana';
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     line-height: 20px;
//     padding:4px;
//     cursor:pointer;
//   }

//   .dropdown-item:hover {
//     color:#216bb1;
//   }

//   @media only screen and (max-width: 768px) {
//     .desktop {
//       display:none;
//     }

//     .mobile {
//       display: flex;
//     }
//   }
// `;

// export const NavbarDropdownContainer = styledComponent.div<any>`
//   position: relative;
//   .dropdown-menu {
//     position: absolute;
//     left: 0;
//     top: 100%;
//     width:calc(100% + 1px);
//     background-color: #ffffff;
//     padding: .75rem;
//     z-index:8;
//     max-height:250px;
//     overflow:auto;
//     overflow-x:hidden;
//     cursor:default;
//     ::-webkit-scrollbar {
//       width:0;
//     }

//   }

//   .dropdown-item {
//     position: relative;
//     left: 65.5%;
//     width: 150px;
//     font-family: 'Verdana';
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     line-height: 20px;
//     color: #000000;
//     padding:4px;
//     cursor: pointer;
//     @media only screen and (max-width: 3072px) {
//       left: 2082px;
//   }
//     @media only screen and (max-width: 2304px) {
//       left: 1540px;
//   }
//     @media only screen and (max-width: 2048px) {
//       left: 1360px;
//   }
//     @media only screen and (max-width: 1920px) {
//       left: 1270px;
//   }
//     @media only screen and (max-width: 1707px) {
//       left: 1119px;
//   }
//     @media only screen and (max-width: 1536px) {
//       left: 997px;
//   }
//     @media only screen and (max-width: 1397px) {
//       left: 900px;
//   }
//   @media only screen and (max-width: 1229px) {
//     left: 65.5%;
// }

//   .dropdown-item:hover {
//     color:#216bb1;
//   }

//   @media only screen and (max-width: 768px) {
//     .desktop {
//       display:none;
//     }

//     .mobile {
//       display: flex;
//     }
//   }
// `;
